import React from "react";

const IndustrialCommercialMachineryComputerEquipmentIcon = ({
  color = "#5D5D5D",
  width = "23",
  height = "21",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 23 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.5003 19.2983H16.6387C23.4099 15.0322 23.0238 5.03575 15.9436 1.3047C8.86336 -2.42635 0.399238 2.9063 0.708166 10.9035C0.923804 16.4858 5.51247 20.8997 11.0989 20.8985H21.5003C22.1162 20.8985 22.5012 20.2318 22.1932 19.6984C22.0503 19.4508 21.7862 19.2983 21.5003 19.2983ZM11.0989 1.696C12.6416 1.69431 14.1573 2.10041 15.4925 2.87315C14.5283 3.30915 13.5964 3.8135 12.7041 4.38235C11.2916 3.48166 9.78186 2.74354 8.20353 2.18206C9.13441 1.85819 10.1133 1.69386 11.0989 1.696ZM6.15426 3.2202C7.94762 3.70553 9.66711 4.43121 11.2659 5.37748C10.5827 5.89172 9.92923 6.44435 9.30868 7.03271C7.66668 6.15894 5.90017 5.54267 4.07098 5.20546C4.65269 4.4347 5.35638 3.76412 6.15426 3.2202ZM3.16987 6.67866C4.89706 6.93108 6.57359 7.45458 8.13753 8.22986C7.58214 8.84019 7.06031 9.48022 6.57432 10.1471C5.2576 9.5561 3.85883 9.1683 2.42576 8.99697C2.56456 8.1933 2.81501 7.41298 3.16987 6.67866ZM2.29775 10.5972C3.45513 10.7402 4.58707 11.0432 5.6612 11.4973C4.90294 12.7146 4.26421 14.0025 3.75394 15.3428C2.82071 13.9346 2.31497 12.2864 2.29775 10.5972ZM4.9401 16.779C6.88437 10.9459 11.2942 6.26215 16.9997 3.9703C17.6313 4.54174 18.1776 5.20088 18.6219 5.92756C12.9666 7.90601 8.62954 12.5152 6.99837 18.2802C6.24388 17.8815 5.55096 17.3759 4.9411 16.779H4.9401ZM10.8649 19.2983C10.0558 19.2756 9.25373 19.141 8.48156 18.8983C9.94629 13.4873 14.0154 9.16459 19.328 7.37575C19.6156 8.13215 19.7967 8.92483 19.8661 9.73106C15.5068 11.2948 12.1602 14.8519 10.8649 19.2983ZM19.8481 11.4533C19.4164 15.3593 16.4527 18.5085 12.5801 19.1763C13.779 15.6756 16.4271 12.8606 19.8481 11.4503V11.4533Z"
        fill={color}
      />
    </svg>
  );
};

export default IndustrialCommercialMachineryComputerEquipmentIcon;
